"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsHandler = void 0;
var shapedivernodemodule_viewersettings_1 = require("shapedivernodemodule-viewersettings");
var StateDashboard_1 = require("../../modules/shapediver-state-dashboard/StateDashboard");
var MessagingConstants_1 = __importDefault(require("../../shared/constants/MessagingConstants"));
var PluginConstantsGlobal_1 = __importDefault(require("../../shared/constants/PluginConstantsGlobal"));
var MessagePrototype_1 = __importDefault(require("../../shared/messages/MessagePrototype"));
var GlobalUtils_1 = __importDefault(require("../../shared/util/GlobalUtils"));
var ViewerAppConstants_1 = __importDefault(require("../ViewerAppConstants"));
var SettingsHandler = /** @class */ (function () {
    // #region Constructors (1)
    function SettingsHandler(_app) {
        this._app = _app;
        this._viewportSettingsRestored = false;
    }
    // #endregion Constructors (1)
    // #region Public Methods (7)
    SettingsHandler.prototype.messageReceiver = function (token, data, type, origin) {
        return __awaiter(this, void 0, void 0, function () {
            var objJSON_2_0, parameterSettings, m, dashboard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._storedSettings)
                            return [2 /*return*/];
                        if (!(type === ViewerAppConstants_1.default.messageDataTypes.APP_SETTINGS)) return [3 /*break*/, 4];
                        objJSON_2_0 = data ? new shapedivernodemodule_viewersettings_1.SettingsConversion().convert(data, '2.0') : null;
                        this._storedSettings = new shapedivernodemodule_viewersettings_1.Settings_2_0(objJSON_2_0);
                        this._storedSettingsOrigin = origin;
                        parameterSettings = this._storedSettings.toJSON(true).parameters;
                        parameterSettings.plugin = origin.plugin;
                        m = new MessagePrototype_1.default(MessagingConstants_1.default.messageDataTypes.PARAMETER_SETTINGS, parameterSettings, origin);
                        this._app.message(MessagingConstants_1.default.messageTopics.PARAMETER_REGISTER, m);
                        this._app.message(MessagingConstants_1.default.messageTopics.EXPORT_REGISTER, m);
                        if (!this._app.getSetting('useModelSettings')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.restoreSettings()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.resolveSettingsRestoredStates();
                        this._app.message(MessagingConstants_1.default.messageTopics.SETTINGS_REGISTERED, new MessagePrototype_1.default(MessagingConstants_1.default.messageDataTypes.GENERIC, {}));
                        _a.label = 3;
                    case 3:
                        dashboard = StateDashboard_1.StateDashboardLibrary.getInstance(this._app.api({ version: 2 }).getSetting('viewerRuntimeId'));
                        dashboard.settingsLoaded.resolve(true);
                        this._app.updateSetting('viewer.hasRestoredSettings', true);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SettingsHandler.prototype.resolveSettingsRestoredStates = function (viewportApi) {
        var states = [];
        var dashboard = StateDashboard_1.StateDashboardLibrary.getInstance(this._app.api({ version: 2 }).getSetting('viewerRuntimeId'));
        if (viewportApi) {
            states.push(dashboard.createCustomState(viewportApi.getViewportRuntimeId() + '_settingsRestored'));
        }
        else {
            var apis = this._app.viewportManager.getApis();
            for (var i = 0, len = apis.length; i < len; i++)
                states.push(dashboard.createCustomState(apis[i].getViewportRuntimeId() + '_settingsRestored'));
        }
        for (var i = 0; i < states.length; i++)
            states[i].resolve(true);
    };
    SettingsHandler.prototype.restoreSettings = function (viewportApi) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var dashboard, settingsObj, _b, _c, _i, k, settingName, apis, i, len, settingName;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        dashboard = StateDashboard_1.StateDashboardLibrary.getInstance(this._app.api({ version: 2 }).getSetting('viewerRuntimeId'));
                        if (viewportApi && ((_a = dashboard.getCustomState(viewportApi.getViewportRuntimeId() + '_settingsRestored')) === null || _a === void 0 ? void 0 : _a.resolved))
                            return [2 /*return*/, Promise.resolve(true)];
                        if (!this._app.getSetting('useModelSettings')) {
                            this.resolveSettingsRestoredStates(viewportApi);
                            return [2 /*return*/, Promise.resolve(true)];
                        }
                        if (!this._storedSettings)
                            return [2 /*return*/, Promise.resolve(false)];
                        settingsObj = this._storedSettings.getSettings(true);
                        _b = [];
                        for (_c in settingsObj)
                            _b.push(_c);
                        _i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(_i < _b.length)) return [3 /*break*/, 13];
                        k = _b[_i];
                        if (!k.startsWith('viewer.scene.')) return [3 /*break*/, 8];
                        settingName = k.replace('viewer.scene.', '');
                        if (!viewportApi) return [3 /*break*/, 3];
                        return [4 /*yield*/, viewportApi.updateSettingAsync(settingName, settingsObj[k])];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 7];
                    case 3:
                        apis = this._app.viewportManager.getApis();
                        i = 0, len = apis.length;
                        _d.label = 4;
                    case 4:
                        if (!(i < len)) return [3 /*break*/, 7];
                        return [4 /*yield*/, apis[i].updateSettingAsync(settingName, settingsObj[k])];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        i++;
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 12];
                    case 8:
                        if (!(k.startsWith('defaultMaterial.') || k.startsWith('ar.'))) return [3 /*break*/, 10];
                        return [4 /*yield*/, this._app.updateSettingAsync(k, settingsObj[k])];
                    case 9:
                        _d.sent();
                        return [3 /*break*/, 12];
                    case 10:
                        if (!k.startsWith('viewer.')) return [3 /*break*/, 12];
                        settingName = k.replace('viewer.', '');
                        return [4 /*yield*/, this._app.updateSettingAsync(settingName, settingsObj[k])];
                    case 11:
                        _d.sent();
                        _d.label = 12;
                    case 12:
                        _i++;
                        return [3 /*break*/, 1];
                    case 13:
                        this.resolveSettingsRestoredStates(viewportApi);
                        // the first time the settings are restored in an actual viewport
                        if ((viewportApi || this._app.viewportManager.getApis().length > 0) && !this._viewportSettingsRestored) {
                            this._viewportSettingsRestored = true;
                            this._app.message(MessagingConstants_1.default.messageTopics.SETTINGS_REGISTERED, new MessagePrototype_1.default(MessagingConstants_1.default.messageDataTypes.GENERIC, {}));
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    SettingsHandler.prototype.saveSettings = function (runtimeId) {
        return __awaiter(this, void 0, void 0, function () {
            var settingsPlugin, settingsObject, settingsToStore, firstViewportApi, objJSON_2_0;
            return __generator(this, function (_a) {
                if (!GlobalUtils_1.default.typeCheck(runtimeId, 'string')) {
                    // try whether settings can be saved to plugin defined by _storedSettingsOrigin
                    if (this._storedSettingsOrigin && this._storedSettingsOrigin.plugin) {
                        settingsPlugin = this._app.pluginManager.getPluginByRuntimeId(this._storedSettingsOrigin.plugin);
                        if (settingsPlugin && !settingsPlugin.getCapabilities().includes(PluginConstantsGlobal_1.default.pluginCapabilities.SETTINGS)) {
                            settingsPlugin = undefined;
                        }
                    }
                    if (!settingsPlugin) {
                        settingsPlugin = this._app.pluginManager.getPluginByCapabilities(PluginConstantsGlobal_1.default.pluginCapabilities.SETTINGS);
                    }
                }
                else {
                    settingsPlugin = this._app.pluginManager.getPluginByRuntimeId(runtimeId);
                }
                if (!settingsPlugin || !GlobalUtils_1.default.typeCheck(settingsPlugin.saveSettings, 'function')) {
                    return [2 /*return*/, false];
                }
                settingsObject = new shapedivernodemodule_viewersettings_1.Settings_2_0();
                settingsToStore = settingsObject.toJSON(true);
                this._getParameterSettings(settingsToStore.parameters, settingsPlugin.getRuntimeId());
                settingsToStore.viewer.commitParameters = this._app.getSetting('commitParameters');
                settingsToStore.defaultMaterial = {
                    bumpAmplitude: this._app.getSetting('defaultMaterial.bumpAmplitude'),
                    color: this._app.getSetting('defaultMaterial.color'),
                    metalness: this._app.getSetting('defaultMaterial.metalness'),
                    roughness: this._app.getSetting('defaultMaterial.roughness'),
                };
                firstViewportApi = this._app.viewportManager.getApis()[0];
                firstViewportApi.camera.updateAsync(firstViewportApi.camera.get().data, { default: true, duration: 0 });
                settingsToStore.viewer.scene = firstViewportApi.getSettings();
                // has to be done like this, as these settings are not within the list of accessible settings
                settingsToStore.viewer.scene.lights.helper = false;
                settingsToStore.viewer.scene.lights.lightScene = firstViewportApi.getSetting('lights.lightScene');
                settingsToStore.viewer.scene.lights.lightScenes = firstViewportApi.getSetting('lights.lightScenes');
                objJSON_2_0 = new shapedivernodemodule_viewersettings_1.Settings_2_0(settingsToStore).toJSON(true);
                return [2 /*return*/, settingsPlugin.saveSettings(objJSON_2_0)];
            });
        });
    };
    SettingsHandler.prototype._getParameterSettings = function (settings, plugin) {
        var _settings = {};
        var parameterSettings = this._app.parameterManager.getConfig(plugin);
        Object.keys(parameterSettings).forEach(function (key) {
            if (parameterSettings[key]) {
                if (_settings.hasOwnProperty(key)) {
                    _settings[key] = __spread(_settings[key], parameterSettings[key]);
                }
                else {
                    _settings[key] = parameterSettings[key];
                }
            }
        });
        // add controlNames, controlOrder, parametersHidden of exports
        var exportSettings = this._app.exportManager.getConfig(plugin);
        Object.keys(exportSettings).forEach(function (key) {
            if (exportSettings[key]) {
                if (_settings.hasOwnProperty(key)) {
                    _settings[key] = __spread(_settings[key], exportSettings[key]);
                }
                else {
                    _settings[key] = exportSettings[key];
                }
            }
        });
        // controlNames array to object
        settings.controlNames = {};
        if (_settings.hasOwnProperty('controlNames')) {
            var tmp = _settings['controlNames'];
            tmp.forEach(function (kvp) { return (settings.controlNames[kvp.id] = kvp.name); });
        }
        // controlOrder array conversion
        settings.controlOrder = [];
        if (_settings.hasOwnProperty('controlOrder')) {
            var tmp = _settings['controlOrder'];
            tmp.sort(function (a, b) { return (a.order - b.order); });
            settings.controlOrder = tmp.map(function (kvp) { return (kvp.id); });
        }
        // parametersHidden can be assigned directly
        settings.parametersHidden = [];
        if (_settings.hasOwnProperty('parametersHidden')) {
            settings.parametersHidden = _settings['parametersHidden'];
        }
    };
    return SettingsHandler;
}());
exports.SettingsHandler = SettingsHandler;
